import React, { useEffect, useRef, useState } from "react";
import { formaterDuree } from "./horsConnexion";

/**
 * Compte à rebours du blocage temporaire : barre qui se vide + temps restant
 * en m:ss. Redémarre quand `secondes` change ; appelle `onFin` à zéro.
 */
const CompteurBlocage = ({ secondes, onFin }) => {
  const total = Math.max(0, Math.floor(secondes || 0));
  const [restant, setRestant] = useState(total);
  const finRef = useRef(onFin);
  finRef.current = onFin;

  useEffect(() => {
    setRestant(total);
  }, [total]);

  useEffect(() => {
    if (restant <= 0) {
      if (finRef.current) finRef.current();
      return undefined;
    }
    const t = setTimeout(() => setRestant((r) => r - 1), 1000);
    return () => clearTimeout(t);
  }, [restant]);

  return (
    <div className="compteur">
      <div className="barre" aria-hidden="true">
        <span style={{ transform: `scaleX(${total > 0 ? restant / total : 0})` }} />
      </div>
      <b data-testid="temps-restant">{formaterDuree(restant)}</b>
    </div>
  );
};

export default CompteurBlocage;
